import React from 'react';
import AppBar from 'components/app-bar/app-bar';

export default function DiscussionRouter() {
  return <AppBar title="Discussion"></AppBar>;
}
